// DO NOT DELETE window.initializeRemote.
//
// This host no longer needs it for its own remotes — @wlc360/build 0.4.0 emits
// real `<key>@<entry>` references and the @wlc360/build/runtime plugin resolves
// them in the browser. But it is not a host-internal helper: it is a global
// contract the *deployed* remotes call to resolve their own remotes. The
// deployed app-tools bundle contains, literally:
//
//   65025(e){ e.exports = window.initializeRemote("looker_workspaces") },
//   13246(e){ e.exports = window.initializeRemote("model_factory") }
//
// Remove this and those return undefined, so the first consumption fails with
// `TypeError: e is not a function while loading "./Constants" from 65025`,
// React never mounts, and the page is blank.
//
// It can only go away once every deployed remote stops calling it — i.e. after
// they migrate to MF 2.0 runtime resolution too.
interface Environment {
	build_env: string;
	fed_env: string;
}
interface Window {
	webpackEnvironment: Environment;
	initializeRemote: (
		remoteKey: string,
		webpackEnvironment: Environment,
		overrideUrl?: string,
	) => Promise<void>;
}

const getRegion = (
	cloudOsRemotes: string[],
	remoteKey: string,
): string | undefined => {
	if (!cloudOsRemotes.includes(remoteKey)) return;

	// Only cloudos remotes have region
	if (window.origin.includes('-eu')) return 'eu';
	if (window.origin.includes('-ap')) return 'ap';

	return;
};

const getEnvironment = async (): Promise<Environment> => {
	const file = await fetch('/environment.json');
	return await file.json();
};

// prettier-ignore
window.initializeRemote = async (
	remoteKey: string,
	webpackEnvironment: Environment,
	overrideUrl?: string,
) => {
	const { REMOTES, getFederatedEnv, getRemote } = await import('@innovyze/lib_get_remote');
	const cloudOsRemotes = [
		REMOTES.TOOLS,
		REMOTES.DASHBOARD,
		REMOTES.AM_DATA_MANAGEMENT,
		REMOTES.ADMIN,
		REMOTES.ALERTS_MANAGEMENT,
		REMOTES.INCIDENT_MANAGEMENT,
		REMOTES.LIFT_STATIONS,
		REMOTES.MAP,
		REMOTES.WORKSPACES,
		REMOTES.IMPACT_SIMULATIONS,
		REMOTES.DATA_EXPLORER,
		REMOTES.MODEL_FACTORY
	];

	const FALLBACK_ENV = { build_env: 'DEV', fed_env: 'DEV' };
	let env, url;

	// Set the webpack ENV settings
	try {
		console.log(`bootsrap: ${remoteKey}`);
		env = webpackEnvironment ?? (await getEnvironment());
	} catch (error) {
		console.warn('[MFE] Failed to fetch environment information. Using fallback environment.', { error, FALLBACK_ENV });
		env = FALLBACK_ENV;
	} finally {
		window.webpackEnvironment = env as Environment;
	}

	// Set the remote URL
	if (!overrideUrl) {
		const region = getRegion(cloudOsRemotes, remoteKey);
		const federatedEnv = getFederatedEnv(env as Parameters<typeof getFederatedEnv>[0]);
		const remote = getRemote(remoteKey as Parameters<typeof getRemote>[0], federatedEnv, region);
		const [remoteReference] = Object.values(remote);

		url = remoteReference.split('@')[1];
	} else {
		url = overrideUrl;
	}

	return new Promise(resolve => {
		const script = document.createElement('script');

		script.src = url;
		script.async = true;
		script.onload = () => {
			// @ts-expect-error unknown key type
			resolve(window[remoteKey]);
		};

		document.head.appendChild(script);
	});
};

console.log('* Info360 Insight App Is Loading... *');

/* eslint-disable @typescript-eslint/ban-ts-ignore */
//@ts-ignore
import('./index');
